import { practicalStep, type TourStep } from "./runTour"

/**
 * Hands-on walkthrough of the "soporte técnico resuelve incidencias de
 * cuenta" story (openspec/changes/gestion-panel-user-stories,
 * gestion-support-account-resolution) against the real StudentsManager.tsx
 * page. The tour doesn't advance until you actually do each step on the
 * real UI — if a step never unblocks, that's the flow being broken, not
 * the tour.
 */
export const supportAccountsTourSteps: TourStep[] = [
  {
    popover: {
      title: "Tutorial práctico: resolver una cuenta",
      description:
        "Vas a hacer, en vivo, lo que un soporte técnico haría: buscar un estudiante y abrir sus opciones de cuenta. Cada paso espera tu acción real — no avanza hasta que la hagas.",
    },
  },
  practicalStep(
    {
      element: '[data-tour="module-search"]',
      popover: {
        title: "👉 Hazlo tú: busca un estudiante",
        description: "Escribe al menos 2 letras de un nombre o email real en este campo. El paso avanza solo cuando escribas.",
        side: "bottom",
      },
    },
    "input",
    2,
  ),
  {
    element: '[data-tour="module-table"] tbody tr:first-child',
    popover: {
      title: "Resultado real",
      description: "Esta es la fila del estudiante que coincide con tu búsqueda — mira su estado (Activo/Bloqueado) antes de seguir.",
      side: "top",
    },
  },
  practicalStep({
    element: '[data-tour="module-table"] tbody tr:first-child .dropdown-toggle',
    popover: {
      title: "👉 Hazlo tú: abre sus acciones",
      description: 'Haz clic en el botón "⋮" de esa fila para abrir el menú real de acciones sobre esta cuenta.',
      side: "left",
    },
  }),
  {
    popover: {
      title: "Ya tienes el menú abierto",
      description:
        'Ahí están "Ver perfil", "Restablecer contraseña" y "Bloquear/Activar" — las tres acciones de la historia de soporte, funcionando de verdad. Si quieres probar "Restablecer contraseña" ahora, hazlo con cuidado: es una acción real que cambia la contraseña de esa cuenta y la muestra en pantalla en texto plano.',
    },
  },
  {
    popover: {
      title: "Lo que falta (gap real)",
      description:
        "Esta pantalla vive detrás de la policy \"academy:students\" — para dar un rol \"soporte técnico\" acotado a exactamente esto (sin el resto de Academia), créalo en Sistema → Roles y permisos con solo ese permiso marcado. Sigue sin haber edición de email desde aquí (ni desde la API), ni un registro de auditoría de quién restableció o bloqueó qué cuenta y cuándo.",
    },
  },
]
